var styles = {
  "Activator": "Polaris-Picker-Activator",
  "disabled": "Polaris-Picker-Activator--disabled"
};

export { styles as default };
